export function getCategoryChildCount(hierarchy, categoryId) {
  const cat = (hierarchy || []).find((c) => String(c.id) === String(categoryId));
  return cat?.subcategories?.length ?? 0;
}

export function getSubcategoryChildCount(hierarchy, subcategoryId) {
  for (const c of hierarchy || []) {
    const sub = (c.subcategories || []).find((s) => String(s.id) === String(subcategoryId));
    if (sub) return sub.families?.length ?? 0;
  }
  return 0;
}

export function isRowBulkDeletable(variant, row, hierarchy, lowerLevelCounts = {}, blockRecetaOrigin = false) {
  if (!row?.id) return false;

  if (blockRecetaOrigin) {
    if (variant === 'categories' && row.receta_category_id != null && row.receta_category_id !== '') {
      return false;
    }
    if (variant === 'subcategories' && row.receta_subcategory_id != null && row.receta_subcategory_id !== '') {
      return false;
    }
    if (variant === 'families' && row.receta_family_id != null && row.receta_family_id !== '') {
      return false;
    }
  }

  if (variant === 'categories') {
    return getCategoryChildCount(hierarchy, row.id) === 0;
  }
  if (variant === 'subcategories') {
    return getSubcategoryChildCount(hierarchy, row.id) === 0;
  }
  if (variant === 'families') {
    return (lowerLevelCounts[row.id] ?? 0) === 0;
  }
  return false;
}

export function buildCountMap(items, idField) {
  const map = {};
  for (const item of items || []) {
    const id = item?.[idField];
    if (id == null || id === '') continue;
    map[id] = (map[id] || 0) + 1;
  }
  return map;
}

export function bulkDeleteBlockedReason(variant) {
  if (variant === 'categories') return 'tiene subcategorías registradas';
  if (variant === 'subcategories') return 'tiene familias registradas';
  return 'tiene recetas o productos asociados';
}
